import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import config from '../config';
import { withPrefix } from 'gatsby-link';

// Components
import Header from '../components/Header';
import Footer from '../components/Footer';

// Styles
import '../styles/global.js';
import '../styles/index.css';

const StyledContentSection = styled.div`
  padding: 1rem 2rem;
`;

const StyledWrapper = styled.div`
  padding: 0;
  margin: 0;
  background: white;
`;

const HomeLayout = (props) => {
  const { children } = props;
  return (
    <StyledWrapper>
      <Helmet
        defaultTitle={config.APP_NAME}
        titleTemplate={`%s | ${config.APP_NAME}`}>
        <link rel='icon' type='image/png' href={withPrefix('/images/favicon-32x32.png')} sizes='32x32' />
        <link rel='icon' type='image/png' href={withPrefix('/images/favicon-16x16.png')} sizes='16x16' />
      </Helmet>
      <Header light={false} />
      <StyledContentSection>
        {children()}
      </StyledContentSection>
      <Footer />
    </StyledWrapper>
  );
}

HomeLayout.propTypes = {
  children: PropTypes.any,
};

export default HomeLayout;



// WEBPACK FOOTER //
// ./src/layouts/HomeLayout.jsx